import { render, staticRenderFns } from "./tech-skills-items.vue?vue&type=template&id=9dcca6e6&scoped=true&"
import script from "./tech-skills-items.vue?vue&type=script&lang=js&"
export * from "./tech-skills-items.vue?vue&type=script&lang=js&"
import style0 from "./tech-skills-items.vue?vue&type=style&index=0&id=9dcca6e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcca6e6",
  null
  
)

export default component.exports